import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Mail } from "lucide-react";
import memberApi, { formatErr } from "../../lib/memberApi";
import { ASSETS } from "../../data";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await memberApi.post("/member/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatErr(err?.response?.data?.detail) || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] noise-overlay flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 w-full max-w-md border border-white/10 bg-[#0a0a0a] p-10"
      >
        <div className="flex items-center gap-3 mb-8">
          <img src={ASSETS.logo} alt="Ghost The Grid" className="h-10 w-10 object-cover rounded-sm" />
          <span className="font-display font-extrabold uppercase tracking-tight">Reset Access</span>
        </div>

        {sent ? (
          <p data-testid="forgot-sent" className="font-body text-sm text-white/60 leading-relaxed">
            If that email has an account, a reset link is on its way. Check your inbox.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40 flex items-center gap-2 mb-2">
              <Mail size={13} /> We'll email you a reset link
            </p>
            <input
              data-testid="forgot-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-black/40 border border-white/15 px-4 py-3 font-mono text-sm text-white focus:outline-none focus:border-accent transition-colors"
              placeholder="you@email.com"
            />
            {error && <p className="font-mono text-xs text-accent">{error}</p>}
            <button
              data-testid="forgot-submit"
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-accent text-white font-mono uppercase tracking-[0.15em] text-sm px-6 py-4 hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-70"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : "Send Reset Link"}
            </button>
          </form>
        )}
        <Link to="/portal/login" className="inline-block mt-6 font-mono text-[11px] uppercase tracking-[0.15em] text-white/40 hover:text-white transition-colors">← Back to login</Link>
      </motion.div>
    </div>
  );
}
